import { AccountAccessModelDto as BoAccountAccessModelDto } from '@treasury/api/bo';
import { AccountAccessModelDto as ConsumerAccountAccessModelDto } from '@treasury/api/channel';
import { DomainEntity } from '../../../../shared';
import { CompanyAccount } from '../../../company-account.entity';

const defaultAccountAccess: BoAccountAccessModelDto = {
    id: 0,
    hasUserAccess: false,
    hasPendingUserAccess: false,
};

export class AccountAccess extends DomainEntity<
    BoAccountAccessModelDto | ConsumerAccountAccessModelDto
> {
    private get account() {
        return new CompanyAccount(this.dto.companyAccount);
    }

    public get id() {
        return this.dto.id;
    }

    public get accountName() {
        return this.account.accountName;
    }

    public get accountNumber() {
        return this.account.accountNumber;
    }

    public get cifNumber() {
        return this.account.cifNumber;
    }

    public get accountType() {
        return this.account.type;
    }

    public get hasUserAccess() {
        return this.dto.hasUserAccess;
    }

    public get hasPendingUserAccess() {
        return this.dto.hasPendingUserAccess;
    }

    public createDefault(): this {
        return new AccountAccess(defaultAccountAccess) as this;
    }
}
